
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const ReopenWorkProgressTableDataAPI = createAsyncThunk("ReopenWorkProgressTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_AssetTypeID,
        WorkAssignedByID,
        M_UsersID,
        token,
        From,
        To,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_UploadAssignReopenWork_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '1'}&WorkAssignedByID=${WorkAssignedByID ? WorkAssignedByID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : '0'}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ReopenWorkProgressTableDataSlice = createSlice({
    name: "ReopenWorkProgressTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ReopenWorkProgressTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ReopenWorkProgressTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ReopenWorkProgressTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ReopenWorkProgressTableDataReducer = ReopenWorkProgressTableDataSlice.reducer

export const ReopenWorkProgressExportTableDataAPI = createAsyncThunk("ReopenWorkProgressExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_AssetTypeID,
        WorkAssignedByID,
        M_UsersID,
        token,
        From,
        To,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_UploadAssignReopenWork_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '1'}&WorkAssignedByID=${WorkAssignedByID ? WorkAssignedByID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : '0'}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ReopenWorkProgressExportTableDataSlice = createSlice({
    name: "ReopenWorkProgressExportTableData",
    initialState: {
        isExportLoading: false,
        ReopenPendingCompletedTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ReopenWorkProgressExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(ReopenWorkProgressExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ReopenPendingCompletedTableData = action.payload;
        });
        builder.addCase(ReopenWorkProgressExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ReopenPendingCompletedTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ReopenWorkProgressExportTableDataReducer = ReopenWorkProgressExportTableDataSlice.reducer


